import React from 'react';
import ErrorPage from '../../components/ErrorPage';

const ServerErrorPage = ({ staticContext = {} }) => {
    staticContext.serverError = true;
    return (
        <ErrorPage
            showReloadButton={false}
            showBackButton={true}
            data-testid="error-500.error-page"
        />
    );
};

export default ServerErrorPage;
